import i18next from '@frolight/i18n';
import { getLocalizedRichText } from '@frolight/services/localizationService';

const useLocalizationUtils = () => {

  const changeLocale = async (locale) => {

    if (i18next.hasResourceBundle(locale, 'translation')) {
      i18next.changeLanguage(locale);
    } else {
      const localeData = await getLocalizedRichText(locale);
      if (!localeData) {
        console.error(`Failed to load translation file for ${locale}`);
        return;
      }
      i18next.addResourceBundle(locale, 'translation', localeData, true, true);
      await i18next.changeLanguage(locale);
    }
  };

  return { changeLocale };

};

export default useLocalizationUtils;
